import { promoQRPrefix } from '@src/@data/utility/products';

export enum CodeType {
  Reservation = 'reservation',
  Subscription = 'code',
}

export interface ParsedCode {
  type: CodeType;
  value: string;
}

export const parseScannedCode = (code: string): ParsedCode | undefined => {
  if (code.toLowerCase().includes('reservation/')) {
    const value = code.split('reservation/')[1];
    if (!value) {
      return undefined;
    }
    return {
      type: CodeType.Reservation,
      value,
    };
  } else if (code.toLowerCase().includes(`${promoQRPrefix}/`)) {
    const value = code.split(`${promoQRPrefix}/`)[1];
    if (!value) {
      return undefined;
    }
    return {
      type: CodeType.Subscription,
      value,
    };
  }
  return undefined;
};
